const APP_CONF = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    ITEMS_PER_PAGE: 10,
    APPLICATION_ID: 1
};

export default APP_CONF;
